<script lang="ts" generics="TValues">
    import ModalMobileSelectJobTitle from '$lib/components/Form/SelectJobTitle/ModalMobileSelectJobTitle.svelte';

    import ModalMobileSelectCompany from '$lib/components/Form/SelectCompany/ModalMobileSelectCompany.svelte';

    import type { Field, Form } from '@jmvdevelop/svelte-form';
    import StackZIndex from '$components/ZIndex/StackZIndex.svelte';
    import { melt, createDialog, createSync } from '@melt-ui/svelte';
    import MobilePrettyMultiChoiceRow from '$components/Form/ModalMobile/MobilePrettyMultiChoiceRow.svelte';
    import { mediaQuery } from '$lib/utils/store/mediaQuery';
    import ModalMobile from '$components/Form/ModalMobile/ModalMobile.svelte';
    import MobilePrettyChoiceRow from '$components/Form/ModalMobile/MobilePrettyChoiceRow.svelte';
    import ModalMobileSelectCategory from '$components/Form/SelectCategory/ModalMobileSelectCategory.svelte';
    import ScrollView from '$components/ScrollView/ScrollView.svelte';

    import * as JobFiltersData from '$components/SearchHeader/JobFilters/JobFiltersData';
    import * as EducationLevel from '$components/SearchHeader/ProFilters/EducationLevel';
    import * as ExperienceBucket from '$components/SearchHeader/ProFilters/ExperienceBucket';

    import * as Content from '$components/SearchHeader/JobFilters/Content';
    import * as ContractType from '$components/SearchHeader/JobFilters/ContractType';
    import * as Remote from '$components/SearchHeader/JobFilters/Remote';
    import * as WorkTime from '$components/SearchHeader/JobFilters/WorkTime';
    import * as PublicationDate from '$components/SearchHeader/JobFilters/PublicationDate';
    import { getContainer } from '$components/Context/ContainerContext';

    const { lang } = getContainer();

    export let form: Form<TValues, string>;
    export let jobFiltersFields: JobFiltersData.Fields<TValues>;
    export let showFiltersField: Field<TValues, boolean>;

    function resetFilters() {
        form.dispatch(
            form.actions().changeValue(JobFiltersData.empty, jobFiltersFields.self),
        );
    }

    $: showFilters = form.stores().fieldValue(showFiltersField);

    const dialog = createDialog({
        preventScroll: true,
        onOpenChange: ({ next }) => {
            if (!$onMobile) {
                return false;
            }

            return next;
        },
    });

    const {
        elements: { close },
        states: { open },
    } = dialog;

    $: sync = createSync({ open });
    $: sync.open($showFilters, (open) => {
        form.dispatch(form.actions().changeValue(open, showFiltersField));
    });

    const prefixId = 'mobile';
    const onMobile = mediaQuery({ lt: 't' }, false);
</script>

<StackZIndex zIndex={1500}>
    {#if $onMobile}
        <ModalMobile {dialog} transitionStyle="modal" title="Filtrer">
            <ScrollView class="flex-1">
                <MobilePrettyMultiChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.contractTypes}
                    label="Type de contrat"
                    choices={ContractType.prettyChoices($lang)}
                />

                <ModalMobileSelectCategory
                    {form}
                    {prefixId}
                    field={jobFiltersFields.category}
                    label="Secteur d'activité"
                />

                <ModalMobileSelectJobTitle
                    {form}
                    {prefixId}
                    field={jobFiltersFields.jobTitle}
                    label="Metier"
                />

                <ModalMobileSelectCompany
                    {form}
                    {prefixId}
                    field={jobFiltersFields.company}
                    label="Entreprise"
                />

                <MobilePrettyMultiChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.experiences}
                    label="Expérience"
                    areEqual={ExperienceBucket.areEqual}
                    choices={ExperienceBucket.prettyChoices}
                />

                <MobilePrettyChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.workTime}
                    label="Temps de travail"
                    choices={WorkTime.prettyChoices}
                />

                <MobilePrettyMultiChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.educationLevels}
                    label="Niveau d'études"
                    description="Choisissez un ou plusieurs niveaux d'études"
                    choices={EducationLevel.prettyChoices}
                />

                <MobilePrettyChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.remote}
                    label="Télétravail"
                    choices={Remote.prettyChoices}
                />

                <MobilePrettyChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.publicationDate}
                    label="Date de publication"
                    choices={PublicationDate.prettyChoices}
                />

                <!--@TODO
                <ModalMobileSelectSalary
                    {form}
                    {prefixId}
                    field={jobFiltersFields.salary}
                    label="Salaire brut"
                    min={0}
                    max={500}
                />-->

                <MobilePrettyMultiChoiceRow
                    {form}
                    {prefixId}
                    field={jobFiltersFields.contents}
                    label="Contenu de l’annonce"
                    choices={Content.prettyChoices}
                />
            </ScrollView>

            <svelte:fragment slot="footer">
                <button
                    type="button"
                    class="btn-leo btn-leo-primary btn-xl w-full"
                    use:melt={$close}
                >
                    Valider
                </button>

                <button
                    type="button"
                    class="btn-reset flex gap-4 items-center justify-center hover:cursor-pointer hover:opacity-80 text-gray-800 text-14 font-bold"
                    on:click|preventDefault={resetFilters}
                >
                    <i class="tnp tnp-refresh text-12" aria-hidden={true} />
                    Effacer les filtres
                </button>
            </svelte:fragment>
        </ModalMobile>
    {/if}
</StackZIndex>
